





































































































































































































































import moment from 'moment'
import { MachineSettings, PalletPattern } from '@/model/index'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { robots } from '@/api/const'
import { mapGetters, mapState } from 'vuex'
import ConfirmDialog from '@/components/shared/ConfirmDialog.vue'
import SpinnerPopup from '@/components/shared/SpinnerPopup.vue'
import _throttle from 'lodash.throttle'
import { permissions } from '@/userUtils'
import { IUser } from '@/libs/auth'

@Component({
  components: { ConfirmDialog, SpinnerPopup: SpinnerPopup },
  filters: {
    momentFormatted (value: any) {
      return moment(value).format('L LT')
    }
  },
  computed: {
    isSendingById: function () {
      return (id: string) => this.$store.state.palletpatterns.isSending === id
    },
    ...mapGetters ('palletpatterns', ['selectedEntity']),
    ...mapState('environment', ['user']),
    ...mapGetters('settings', ['isPatternValidationEnabled']),
    ...mapGetters('machinesettings', ['machinesettings'])
  }
})
export default class PalletPatternList extends Vue {
  @Prop() private palletPatterns!: PalletPattern[]
  @Prop() private count!: number
  @Prop() private userPermissions!: string[]

  private searchValue: string = ''
  private sortDirection: string = 'desc'
  private selectedSort: string = 'general.lastUpdated'
  private items: string[] = [
    'general.lastUpdated',
    'general.alphaNum'
  ]
  private robotList: Array<{ id: string, title: string, disabled: boolean, tooltip?: string }> = robots
  private selectedFile: any
  private currentPattern: string = ''
  private isSending: boolean = false
  private selectedEntity!: PalletPattern
  private patternInfoCache: any[] = []
  private tryingToSend: string = ''
  private user!: IUser
  private isPatternValidationEnabled!: boolean
  private machinesettings!: MachineSettings

  setSending(value: boolean, pattern: string) {
    this.isSending = value
    this.currentPattern = pattern
    if (!value) {
      this.tryingToSend = ''
    }
  }

  private async downloadBlur(guid: string) {
    if (this.isPortDisabled()) {
      this.$emit('download')
      return
    }
    if (!this.patternInfoCache.some(p => p.guid === guid)) {
      // fetch full pattern by guid
      await this.$store.dispatch ('palletpatterns/getSelectedEntity', guid)
      const source = this.selectedEntity
      const patternInfo = {
        guid: guid,
        ...((source.pallet !== undefined && source.pallet.palletType === 'CUSTOM') && { isCustomPallet: true }),
        ...((source.programSettings !== undefined && source.programSettings.robotType === 'CUSTOM_SOLUTION') && { isCustomSolution: true })
      }
      this.patternInfoCache.push(patternInfo)
    }
  }

  private getRobotList(guid: string) {
    const patternInfo = this.patternInfoCache.find(p => p.guid === guid)
    if (patternInfo && (patternInfo.isCustomPallet || patternInfo.isCustomSolution)) {
      const allowedRobots = patternInfo.isCustomPallet ? ['GENERIC'] : ['GENERIC', 'CUSTOM_SOLUTION']
      const toolTipText = patternInfo.isCustomPallet ? 'Not available for custom pallet' : 'Not available for custom solution'
      return this.robotList.map (r => !allowedRobots.includes(r.id) ?
          {...r, disabled: true, tooltip: toolTipText } : r)
    }
    return this.robotList
  }

  private comboChanged () {
    this.arraySort()
  }

  private downArrowClick () {
    this.sortDirection = 'asc'
    this.arraySort()
  }

  private upArrowClick () {
    this.sortDirection = 'desc'
    this.arraySort()
  }

  private arraySort () {
    if (this.selectedSort === this.$t('general.lastUpdated')) {
      if (this.sortDirection === 'asc') {
        // console.log('ASCENDING')
        this.palletPatterns.sort(this.dateSortAsc)
      } else {
        // console.log('DESCENDING')
        this.palletPatterns.sort(this.dateSortDesc)
      }
    } else if (this.selectedSort === this.$t('general.alphaNum')) {
      if (this.sortDirection === 'asc') {
        // console.log('ASCENDING')
        this.palletPatterns.sort(this.alphaSortAsc)
      } else {
        // console.log('DESCENDING')
        this.palletPatterns.sort(this.alphaSortDesc)
      }
    }
  }

  private alphaSortAsc (a: any, b: any) {
    a = a.name.toUpperCase()
    b = b.name.toUpperCase()
    return a < b ? -1 : b < a ? 1 : 0
  }

  private alphaSortDesc (a: any, b: any) {
    a = a.name.toUpperCase()
    b = b.name.toUpperCase()
    return a > b ? -1 : b > a ? 1 : 0
  }

  private dateSortAsc (a: any, b: any) {
    a = a.updated
    b = b.updated
    return a < b ? -1 : b < a ? 1 : 0
  }

  private dateSortDesc (a: any, b: any) {
    a = a.updated
    b = b.updated
    return a > b ? -1 : b > a ? 1 : 0
  }

  private edit (palletPattern: PalletPattern) {
    this.$emit('edit', palletPattern)
  }

  private remove (palletPattern: PalletPattern) {
    this.$emit('remove', palletPattern)
  }

  private sendToRobot (palletPattern: PalletPattern) {
    if (this.$store.state.palletpatterns.isSending == null
      || (this.$store.state.palletpatterns.isSending.length < 1 && this.tryingToSend.length < 1)) {
      this.$emit('sendToRobot', palletPattern)
      this.tryingToSend = palletPattern.guid!
    }
  }

  private download (palletPattern: PalletPattern, robot: string) {
    this.$emit('download', palletPattern, robot)
  }

  private viewDetails (palletPattern: PalletPattern) {
    this.$emit('viewDetails', palletPattern)
  }

  private sortingItems (): string[] {
    return this.items.map(element => String(this.$t(String(element))))
  }

  private throttledSend(palletPattern: PalletPattern) {
    _throttle(this.sendToRobot(palletPattern), 6000)
  }

  private copy (palletPattern: PalletPattern) {
    _throttle(this.$emit('copy', palletPattern), 2000)
  }

  private isSendToRobotDisabled(): boolean {
    return !this.userPermissions.includes(permissions.TRANSFERPALLETPATTERN)
  }

  private isEditDisabled(): boolean {
    return !this.userPermissions.includes(permissions.MODIFYPALLETPATTERN)
  }

  private isPortDisabled(): boolean {
    return !this.userPermissions.includes(permissions.PORTPALLETPATTERN)
  }

  private isRemoveDisabled(): boolean {
    return !this.userPermissions.includes(permissions.DELETEPALLETPATTERN)
  }

  private isDemo(): boolean {
    return this.user != null
  }

  private isExternalDemoUser(): boolean {
    return this.isDemo() && this.user.roles.includes('rc_demo_user')
  }

  private showDownloadList(): boolean {
    return !this.isPortDisabled() && !this.isExternalDemoUser()
  }

  private getValidationStatusText(status: number): string {
    if (status === 1) {
      return this.$t('patternList.valid').toString()
    }
    if (status === 3) {
      return this.$t('patternList.inValid').toString()
    }
    return this.$t('patternList.notValidated').toString()
  }

  private getStatusColor(status: number): string {
    if (status === 1) {
      return '#66AE76'
    }
    if (status === 3) {
      return '#CC0036'
    }
    return '#A5A3A3'
  }

  private isValidationDisabled(): boolean {
    return !this.userPermissions.includes(permissions.MODIFYPALLETPATTERN)
  }

  private validatePattern(pattern: PalletPattern) {
    _throttle(this.$emit('validatePattern', pattern), 2000)
  }
}
